'use client';

import classes from "./public_provider_room.module.css";
import Check from '@/assets/svg/icons/check.svg';
import X from '@/assets/svg/icons/x.svg';
import FeaturedIcon from "../../common/icons/featured_icon";
import HorizontalTabs from "../../common/horizontal_tabs/horizontal_tabs";
import { useState } from "react";

const tab_options = [
    {id: 1, name: "Befogadóképesség", value: "capacity"},
    {id: 2, name: "Asztal elrendezése", value: "table_layout"}
]

export default function PublicProviderRoomsDesktop({provider, preview_value}) {
    const [activeHorizontal, setActiveHorizontal] = useState("capacity")

    if(!preview_value && (!provider.rooms || provider.rooms.length === 0)) return <></>

    return <>
        <div className="margin-bottom-3 d-flex flex-row align-self-stretch">
            <HorizontalTabs size="lg" options={tab_options} active={activeHorizontal} setActive={setActiveHorizontal} />
            <div className={`${classes["border-placeholder"]} flex-grow-1`}/>
        </div>
        {activeHorizontal === "capacity" && 
            <div className={`${classes["public-provider-rooms-table-container"]}`}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Befogadóképesség</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Ültetett kiszolgálás (fő)</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Svédasztalos kiszolgálás</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Állófogadás</p></div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(preview_value ? preview_value : provider.rooms).map((room, i) => <tr key={`rooms-top-${i}`}>
                            <td><div className={`${classes["cell"]}`}><p className="text-sm-regular">{room.name}</p></div></td>
                            <td><div className={`${classes["cell"]}`}><p className="text-sm-regular">{room.ultetett_kiszolgalas ? room.ultetett_kiszolgalas : "-"}</p></div></td>
                            <td><div className={`${classes["cell"]}`}><p className="text-sm-regular">{room.svedasztalos_kiszolgalas ? room.svedasztalos_kiszolgalas : "-"}</p></div></td>
                            <td><div className={`${classes["cell"]}`}><p className="text-sm-regular">{room.allofogadas ? room.allofogadas : "-"}</p></div></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        }
        {activeHorizontal === "table_layout" && 
            <div className={`${classes["public-provider-rooms-table-container"]}`}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Asztal elrendezések</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Táblaasztalos</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">Körasztalos</p></div></th>
                            <th><div className={`${classes["cell"]}`}><p className="text-xs-medium">U alak</p></div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(preview_value ? preview_value : provider.rooms).map((room, i) => <tr key={`rooms-bottom-${i}`}>
                            <td><div className={`${classes["cell"]}`}><p className="text-sm-regular">{room.name}</p></div></td>
                            <td><div className={`${classes["cell"]}`}><FeaturedIcon size="sm" color={(room.tablaasztalos && +room.tablaasztalos === 1) ? "primary-strong" : "error"} icon={(room.tablaasztalos && +room.tablaasztalos === 1) ? Check : X} />{/*<p className="text-sm-regular">{getMax([room.ultetett_kiszolgalas, room.svedasztalos_kiszolgalas, room.allofogadas])}</p>*/}</div></td>
                            <td><div className={`${classes["cell"]}`}><FeaturedIcon size="sm" color={(room.korasztalos && +room.korasztalos === 1) ? "primary-strong" : "error"} icon={(room.korasztalos && +room.korasztalos === 1) ? Check : X} />{/*<p className="text-sm-regular">{getMax([room.ultetett_kiszolgalas, room.svedasztalos_kiszolgalas, room.allofogadas])}</p>*/}</div></td>
                            <td><div className={`${classes["cell"]}`}><FeaturedIcon size="sm" color={(room.u_alak && +room.u_alak === 1) ? "primary-strong" : "error"} icon={(room.u_alak && +room.u_alak === 1) ? Check : X} />{/*<p className="text-sm-regular">{getMax([room.ultetett_kiszolgalas, room.svedasztalos_kiszolgalas, room.allofogadas])}</p>*/}</div></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        }
    </>
}
